
<div style="position: relative">
    <div style="position: absolute; right: 10px; top: 45px;">
        <slot name="overlay"></slot>
    </div>

    <c-column-header
        :label        = "title"
        class         = "primary white--text"
        :title-border = "true"
    >
        <template v-slot:pre>
            <div  class="audit-menu">
                <c-audit-menu
                    :type        = "type"
                    :device-type = "deviceType"
                    :enums       = "auditEnums"
                    @category    = "onCategory"
                />
            </div>
        </template>

        <template v-slot:toolbar>
            <slot name = "toolbar"></slot>
        </template>
    </c-column-header>

    <div class="bottom-border-radius pb-1" style="border-top-style: none; margin-top: 2px;">
        <div v-if="missingCatalogue" class="pa-4 error--text">
            {{ $t('audit.escalator.missingCatalogue') }}
        </div>

        <div
            v-if = "!missingCatalogue && category && category.id < 100"
        >
            <div class="v-flex pt-3">
                <div style="width: 23%" class="pl-3">
                    <c-audit-index
                        v-if        = "category"
                        style       = "width: 80px"
                        :height     = "height"
                        orientation = "vertical"
                        :category   = "category.id"
                        :enums      = "auditEnums"
                        :data       = "entries"
                        :index      = "catalogueIndex"
                        @selected   = "onIndex"
                    />
                </div>

                <div
                    class  = "pl-2"
                    style  = "width: 65%; padding-right: 14px;"
                    :style = "'height: ' + height + 'px'"
                >
                    <p-audit-catalog-entries
                        v-if              = "category && category.id < 100 && data"
                        :audit-id         = "data.id"
                        :entries          = "entries"
                        :show-header      = "false"
                        :type             = "type"
                        :device-type      = "deviceType"
                        :enums            = "auditEnums"
                        :unit             = "data.unit"
                        :show-budget-data = "showBudgetData"
                        :country          = "country"
                        @index            = "onScroll"
                        ref               = "entries"
                    />
                </div>
            </div>
        </div>

        <p-audit-facilities
            v-if                   = "category && category.id === 100"
            :style                 = "'height: ' + (height+12) + 'px'"
            :facilities            = "data.facilities"
            :customer-measures     = "data['customerMeasure']"
            :manufacturer-measures = "data['manufacturerMeasure']"
        />

        <p-audit-hazards
            :style="'height: ' + (height+12) + 'px'"
            v-if = "category && category.id === 101"
            :show-title = "false"
            :hazards    = "data.hazards"
            :measures   = "data['hazardMeasure']"
        />
    </div>

    <slot name = "bottom"></slot>
</div>
